/*!
// <copyright file="html-binding-serverform-compilation.js" company="Microsoft">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
*/

/// <reference path="html-binding-serverform.js" />
/// <reference path="html-binding-serverform-metadata.js" />
(function () {
    'use strict';

    $dyn.serverForm.compilation = {
        formsCache: {},
        getFormDefinition: function (formName, callback) {
            if (formName) {
                formName = formName.toLowerCase();
            }

            // If the form is already in the local cache, get it from there
            if ($dyn.serverForm.compilation.formsCache[formName]) {
                var form = $dyn.serverForm.compilation.formsCache[formName];
                $dyn.async(function () {
                    callback(form);
                }, 50, "Get form definition callback");
            }
                // Otherwise, request it from the service
            else {
                var ajaxOptions = {};
                ajaxOptions.type = 'GET';
                // If this is design time we need to use a relative path and use the proper extension.
                if ($dyn.flags.useDesignTimeView) {
                    ajaxOptions.url = './webcontent/form/' + formName + '.json';
                }
                else {
                    ajaxOptions.url = $dyn.util.resolveVirtualPath('/webcontent/form/' + formName);
                }
                ajaxOptions.dataType = "json";
                ajaxOptions.success = function (data, textStatus, request) {
                    if (data) {
                        data = $dyn.serverForm.compilation.formsCache[formName] = $dyn.serverForm.compilation.generateViewModel(data);
                    }

                    callback(data);
                };
                ajaxOptions.error = function (request, textStatus, error) {
                    // Execute the callback with no descriptors
                    $dyn.logError(error);
                    callback();
                };

                $.ajax(ajaxOptions);
            }
        },
        generateViewModel: function (viewDescriptor) {
            var elementType = viewDescriptor.TypeName;
            var vm = {
                TypeName: elementType,
                Name: viewDescriptor.Name,
                ValueProperties: {},
                SerializedValueProperties: {},
                ReferenceProperties: {},
                Commands: {},
                PropertyTriggers: {}
            };

            if ($dyn.serverForm.metadata[elementType]) {
                if ($dyn.serverForm.metadata[elementType].ValueProperties) {
                    for (var i = 0, len = $dyn.serverForm.metadata[elementType].ValueProperties.length; i < len; i++) {
                        var prop = $dyn.serverForm.metadata[elementType].ValueProperties[i];
                        var hasProp;

                        if (viewDescriptor.SerializedValueProperties && viewDescriptor.SerializedValueProperties.hasOwnProperty(prop.Name)) {
                            vm.SerializedValueProperties[prop.Name] = viewDescriptor.SerializedValueProperties[prop.Name];
                            viewDescriptor.SerializedValueProperties[prop.Name] = undefined;
                            delete viewDescriptor.SerializedValueProperties[prop.Name];
                            hasProp = true;
                        }
                        else if (viewDescriptor.ValueProperties && viewDescriptor.ValueProperties.hasOwnProperty(prop.Name)) {
                            vm.ValueProperties[prop.Name] = viewDescriptor.ValueProperties[prop.Name];
                            viewDescriptor.ValueProperties[prop.Name] = undefined;
                            delete viewDescriptor.ValueProperties[prop.Name];
                            hasProp = true;
                        }

                        if (!hasProp) {
                            if (prop.ValueType === $dyn.serverForm.ValueType.serialized) {
                                vm.SerializedValueProperties[prop.Name] = prop.Value;
                            }
                            else {
                                vm.ValueProperties[prop.Name] = prop.Value;
                            }
                        }
                    }
                }

                // For form preview we still need old baseline format to keep working. We would get Properties objec instead
                // of ValueProperties/SerializedProperties in baseline
                for (var propertyName in viewDescriptor.Properties) {
                    // view model descriptor is a key/property descriptor pair dictionary
                    var targetProperty;
                    // viewDescriptor.Properties is a key/property value pair dictionary
                    var instancePropertyValue = viewDescriptor.Properties[propertyName];
                    if (vm.ValueProperties.hasOwnProperty(propertyName)) {
                        vm.ValueProperties[propertyName] = instancePropertyValue;
                    }
                    else if (vm.SerializedValueProperties.hasOwnProperty(propertyName)) {
                        vm.SerializedValueProperties[propertyName] = instancePropertyValue;
                    }
                    else {
                        $dyn.log($dyn.format('Unknown property: {0}', propertyName));
                        // For the preview create the properties if they don't exist (we need this for custom controls).
                        if ($dyn.flags.useDesignTimeView) {
                            vm.ValueProperties[propertyName] = instancePropertyValue;
                        }
                    }
                }

                for (var propertyName in viewDescriptor.ValueProperties) {
                    $dyn.log('Unknown property: %s-%s', viewDescriptor.TypeName, propertyName);
                    // For the preview create the properties if they don't exist (we need this for custom controls).
                    if ($dyn.flags.useDesignTimeView) {
                        vm.ValueProperties[propertyName] = instancePropertyValue;
                    }
                }
                for (var propertyName in viewDescriptor.SerializedValueProperties) {
                    $dyn.log('Unknown property: %s-%s', viewDescriptor.TypeName, propertyName);
                    // For the preview create the properties if they don't exist (we need this for custom controls).
                    if ($dyn.flags.useDesignTimeView) {
                        vm.SerializedValueProperties[propertyName] = instancePropertyValue;
                    }
                }

                if (viewDescriptor.ReferenceProperties) {
                    vm.ReferenceProperties = viewDescriptor.ReferenceProperties;
                }

                if (!$dyn.flags.useDesignTimeView) {
                    if (viewDescriptor.Commands) {
                        vm.Commands = viewDescriptor.Commands;
                    }

                    if ($dyn.serverForm.metadata[elementType].Commands) {
                        $.each($dyn.serverForm.metadata[elementType].Commands, function (index, command) {
                            if (!vm.Commands[command.CommandName]) {
                                vm.Commands[command.CommandName] = Object.create(command);
                            }
                        });
                    }

                    if (viewDescriptor.PropertyTriggers) {
                        vm.PropertyTriggers = viewDescriptor.PropertyTriggers;
                    }
                }

                if ($dyn.serverForm.metadata[elementType].PropertyTriggers) {
                    $.each($dyn.serverForm.metadata[elementType].PropertyTriggers, function (index, propertyTrigger) {
                        if (!vm.PropertyTriggers[propertyTrigger.PropertyName]) {
                            vm.PropertyTriggers[propertyTrigger.PropertyName] = Object.create(propertyTrigger);
                        }
                    });
                }
            }

            if (viewDescriptor.ChildViewModels) {
                vm.ChildViewModels = [];
                $.each(viewDescriptor.ChildViewModels, function (key, item) {
                    vm.ChildViewModels.push($dyn.serverForm.compilation.generateViewModel(item));
                });
            }
            if ($dyn.serverForm.compilation.adapters[elementType]) {
                $dyn.serverForm.compilation.adapters[elementType](viewDescriptor, vm);
            }

            return vm;
        }
    };

    $dyn.serverForm.compilation.adapters = {};

    $dyn.serverForm.compilation.adapters.Grid = function (viewDescriptor, viewModelDescriptor) {
        var props = viewDescriptor.ValueProperties !== undefined ? viewDescriptor.ValueProperties : viewDescriptor.Properties;
        if (props) {
            if (props.ListItemViewModelDescriptor && viewModelDescriptor.ValueProperties.ListItemViewModelDescriptor) {
                viewModelDescriptor.ValueProperties.ListItemViewModelDescriptor = $dyn.serverForm.compilation.generateViewModel(props.ListItemViewModelDescriptor);

            }
            if (props.Mode && viewModelDescriptor.ValueProperties.Mode) {
                viewModelDescriptor.ValueProperties.Mode = props.Mode;
            }
            if (props.PrimaryModelName && viewModelDescriptor.ValueProperties.PrimaryModelName) {
                viewModelDescriptor.ValueProperties.PrimaryModelName = props.PrimaryModelName;
            }
        }
    };

    // Server sends value as 1/0 and page compiler uses true/false
    $dyn.serverForm.compilation.adapters.SectionPage = function (viewDescriptor, viewModelDescriptor) {
        var props = viewDescriptor.ValueProperties !== undefined ? viewDescriptor.ValueProperties : viewDescriptor.Properties;
        if (props.Expanded && viewModelDescriptor.ValueProperties.Expanded) {
            viewModelDescriptor.ValueProperties.Expanded = props.Expanded ? 1 : 0;
        }
    };

    $dyn.serverForm.compilation.adapters.Image = function (viewDescriptor, viewModelDescriptor) {
        if (viewModelDescriptor) {
            viewModelDescriptor.PropertyTriggers = viewModelDescriptor.PropertyTriggers || {};
            viewModelDescriptor.PropertyTriggers.Value = {
                PropertyName: 'Value',
                ChangeAction: {
                    ValueTypeName: $dyn.serverForm.CommandName.propertyChange,
                    CommandName: 'Value'
                }
            };
        }
    };

    $dyn.serverForm.compilation.StaticLoader = {
        staticLoaderOn: $dyn.debug.staticLoaderOn || $dyn.flags.useDesignTimeView,

        applyDescriptors: function (interactionHandler, descriptor, targetId) {
            descriptor.Id = targetId;
            var interactionType = $dyn.serverForm.InteractionType.createViewModel;

            var viewModelInteraction = {
                $type: interactionType,
                Descriptor: descriptor,
                RootId: targetId
            };
            $dyn.shell.isPreProcessing = true;
            interactionHandler.processInteractions([viewModelInteraction], true /* disallowBlock */);
            $dyn.shell.isPreProcessing = false;
        },
        load: function (formName, rootElement, formId, interactionHandler) {
            var self = this;
            rootElement.dynReadyState('preloadRequest');
            rootElement.dynPerformance.preloadRequestStart = performance.now();

            // On dev environments in IE, need to give a small delay so that CPU priority can be given to the server request instead of the static loading request.
            var loadingDelay = 0;

            $dyn.async(function () {
                self.loadDefinition(formName, function loadDefinitionCallback(descriptor) {
                    if (rootElement.dynReadyState() === $dyn.ui.ReadyState.preloadRequest) {
                        rootElement.dynPerformance.preloadRequestEnd = performance.now();
                        rootElement.dynPerformance.preloadRequestTime = rootElement.dynPerformance.preloadRequestEnd - rootElement.dynPerformance.preloadRequestStart;
                        rootElement.dynReadyState('preloading');
                        rootElement.dynPerformance.preloadingStart = performance.now();

                        // Only execute preloading logic if descriptors exist
                        if (descriptor != null) {

                            // Set dynPreloaded to true to indicate that statically generated form was found and loaded.
                            rootElement.dynPreloaded = true;

                            // Load static form.
                            // Current pattern is to have placed in the DOM earlier, so if we can't find the element we should take no action.

                            if (formId === undefined) {
                                formId = rootElement.getAttribute('data-dyn-formid');
                            }

                            var rootControl = $dyn.context(rootElement);
                            var rootDataSource = rootControl && rootControl.DataSource;
                            if (rootDataSource) {
                                // Set the name on the root model to be the form name because static loading doesn't have a model interaction to set it. 
                                rootDataSource.collectionName = descriptor.Name;
                            }

                            if ($(rootElement).closest(document.body).length) {
                                $dyn.serverForm.compilation.StaticLoader.applyDescriptors(interactionHandler, descriptor, formId);
                            } else {
                                $dyn.log("Ignoring applyDescriptors because the parent form was already closed.");
                            }
                        }

                        rootElement.dynPerformance.preloadingEnd = performance.now();
                        rootElement.dynPerformance.preLoadingTime = rootElement.dynPerformance.preloadingEnd - rootElement.dynPerformance.preloadRequestStart;
                        rootElement.dynReadyState('request');

                        $dyn.log.server && $dyn.log.server('ServerForm: Static loading completed: %s', formName);
                    }
                    else {
                        $dyn.log.server && $dyn.log.server("Attempted to set dynReadyState from %s to preloading", rootElement.dynReadyState());
                    }
                    // Unblock the channel for rest of the processing, i.e. handle pending interactions such as the loading
                    interactionHandler.blockInbound(false);
                });
            }, loadingDelay, "StaticLoader load");
        },

        loadDefinition: function (formName, callback) {
            $dyn.serverForm.compilation.getFormDefinition(formName, callback);
        }
    };
})();
